import React from "react";
import Axios from "axios";
import Moment from "react-moment";
import moment from "moment";
import { createAlert } from "../actions/utils";
import { doLogout } from "../actions/session";
import Tooltip from "../components/atoms/Tooltip";
import fileDownload from "js-file-download";
import querystring from "querystring";
import sanitizeHtml from 'sanitize-html';

import "moment-timezone";

export function downloadFile(data: any, title: string) {
    if (data && data !== null) {
        // Adding "\uFEFF" to the beginning of the text forces the output file to parse none english
        // characters (i.e French) properly.
        fileDownload("\uFEFF" + data, title);
    }
}

export function isURL(url: string) {
    return /^(?:(?:https?):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(
        url
    );
}

export function isHttpsURL(url: string) {
    return /^(?:(?:https):\/\/)(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)$/.test(
        url
    );
}

/* Sorting an object or array. Single depth only */
export function sortObject(data: dynamic) {
    interface ISortedValue {
        key: string;
        val: string;
    }
    let sorted: ISortedValue[] = [];
    const arrayKeys: string[] = [];
    if (data && typeof data == "object") {
        Object.keys(data).forEach(key => {
            if (data[key] && data[key].constructor === Array) {
                arrayKeys.push(key);
                data[key].forEach(v => {
                    sorted.push({ key, val: v });
                });
            } else {
                sorted.push({ key, val: data[key] });
            }
        });
    } else {
        sorted = data || [];
    }
    sorted.sort((a, b) => {
        return a.val.toLowerCase() > b.val.toLowerCase() ? 1 : b.val.toLowerCase() > a.val.toLowerCase() ? -1 : 0;
    });

    if (typeof data == "object") {
        data = {};
        sorted.forEach(obj => {
            if (data[obj.key]) {
                if (typeof data[obj.key] == "string") {
                    const val = data[obj.key];
                    data[obj.key] = [val, obj.val];
                } else {
                    data[obj.key].push(obj.val);
                }
            } else {
                if (arrayKeys.indexOf(obj.key) !== -1) {
                    data[obj.key] = [obj.val];
                } else {
                    data[obj.key] = obj.val;
                }
            }
        });
    } else {
        data = sorted;
    }

    return data;
}

export function correctHeight() {
    const pageWrapper = $("#page-wrapper");
    const navbarHeight = $("nav.navbar-static-top").height() || 0;
    const wrapperHeight = pageWrapper.height() || 0;
    const windowHeight = $(window).height() || 0;

    if (navbarHeight > wrapperHeight) {
        pageWrapper.css("min-height", navbarHeight + "px");
    }

    if (navbarHeight <= wrapperHeight) {
        if (navbarHeight < windowHeight) {
            pageWrapper.css("min-height", $(window).height() + "px");
        } else {
            pageWrapper.css("min-height", navbarHeight + "px");
        }
    }

    if ($("body").hasClass("fixed-nav")) {
        if (navbarHeight > wrapperHeight) {
            pageWrapper.css("min-height", navbarHeight + "px");
        } else {
            pageWrapper.css("min-height", windowHeight - 60 + "px");
        }
    }
}

function getTimeFormat(time: number, label: string, prepend = "") {
    if (time > 0) {
        return `${prepend ? prepend : ""}${time} ${label}${time > 1 ? "s" : ""}`;
    }
    return "";
}

export function getHumanDuration(time: number) {
    const years = Math.floor(time / 31536000);
    const days = Math.floor((time % 31536000) / 86400);
    const hours = Math.floor(((time % 31536000) % 86400) / 3600);
    const minutes = Math.floor((((time % 31536000) % 86400) % 3600) / 60);
    const seconds = (((time % 31536000) % 86400) % 3600) % 60;
    return `${getTimeFormat(years, "year")}${getTimeFormat(days, "day", years > 0 ? ", " : "")}${getTimeFormat(
        hours,
        "hour",
        days > 0 ? ", " : ""
    )}${getTimeFormat(minutes, "minute", hours > 0 ? ", " : "")}${getTimeFormat(
        seconds,
        "second",
        minutes > 0 ? ", " : ""
    )}`;
}
export function getRange(start: number, end: number, step = 1) {
    return Array.apply(null, new Array(Math.floor((end - start) / step) + 1)).map((_, idx) => start + idx * step);
}

export function preventDefault(e: KeyboardEvent | React.KeyboardEvent) {
    const key = e.charCode || e.keyCode || 0;
    if (key == 13 && e.target && !$(e.target).is("textarea")) {
        e.preventDefault();
    }
}

//TODO: seems to be sgc-specific? look into whether this works for pp and fix if necessary
function getComplianceErrors(article: ServerTypes.Console.IArticle) {
    if (article.status != "rejected") {
        return;
    }
    // only place this type is used
    const evidence: Mongo.ICachedStreamArticleComplianceEvidence[] = [];
    if (article.compliance) {
        article.compliance.forEach(item => {
            if (item.violations) {
                item.violations.forEach(itemViolations => {
                    if (itemViolations.evidences) {
                        itemViolations.evidences.forEach(itemEvidences => {
                            evidence.push(itemEvidences);
                        });
                    }
                });
            }
        });
    }
    if (evidence.length == 0) {
        return;
    }
    return [
        <hr />,
        <ul
            style={{
                background: "transparent",
                padding: 0,
                margin: 0
            }}
        >
            <li
                style={{
                    background: "transparent",
                    color: "#fff",
                    padding: "10px 0",
                    textAlign: "left",
                    listStyleType: "none"
                }}
            >
                Comments:
            </li>
            {evidence.map((item, i) => {
                if (item.details && item.facet) {
                    return (
                        <li
                            key={`${item.facet}-${i}`}
                            style={{
                                background: "transparent",
                                color: "#fff",
                                padding: "10px 0"
                            }}
                        >
                            <span>
                                {item.details}
                                :&nbsp;
                            </span>
                            <span>{item.facet}</span>
                        </li>
                    );
                }
                return;
            })}
        </ul>
    ];
}

export function getComplianceMessage(article: ServerTypes.Console.IArticle) {
    const status = article.status;

    if (status) {
        switch (status) {
            case "rejected":
                return (
                    <span>
                        Rejected &nbsp;
                        <Tooltip>Compliance rejected this article {getComplianceErrors(article)}</Tooltip>
                    </span>
                );
            case "pending":
                return (
                    <span>
                        Pending &nbsp;
                        <Tooltip>Waiting for compliance admin to review article</Tooltip>
                    </span>
                );
            case "declined":
                return (
                    <span>
                        Declined &nbsp;
                        <Tooltip>Admin declined the article</Tooltip>
                    </span>
                );
            case "new":
                return (
                    <span>
                        Processing &nbsp;
                        <Tooltip>Processing article to submit to compliance</Tooltip>
                    </span>
                );
            case "suggested":
                return (
                    <span>
                        Suggested &nbsp;
                        <Tooltip>Article needs to be reviewed by an Admin</Tooltip>
                    </span>
                );
            case "approved":
            default:
                return <span>{article.email ? `Approved by ${article.email}` : `Approved`}</span>;
        }
    }
    return null;
}

// TODO: replace this with a call to Utils.getDomain on the backend
// the functions should be the same until then
export function extractHostname(url: string | null) {
    if (!url) return "";
    const matches = url.match(/(^\w+\:\/\/)?([^\/?#]+[\.:][^\/?#]+)(?:[\/?#]|$)/i);
    let splitResult: string[] = [];
    if (matches && matches[2]) {
        if (matches[2].startsWith("www.")) {
            splitResult = matches[2].slice(4).split(".");
            if (splitResult.length > 2) {
                return `${splitResult[splitResult.length - 2]}.${splitResult[splitResult.length - 1]}`;
            }
            return matches[2].slice(4);
        }
    }
    splitResult = matches && matches[2] ? matches[2].split(".") : [];
    if (splitResult.length > 2) {
        return `${splitResult[splitResult.length - 2]}.${splitResult[splitResult.length - 1]}`;
    }
    return (matches && matches[2] || "");
}

/**
 * Return compact localized date string format for use in filenames: yyyMMdd.
 * @param date The date and time to convert
 */
export function getLocaleDate(date: Date) {
    return date
        .toLocaleDateString("ko-KR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        })
        .replace(/\D/g, "");
}

/**
 * Returns the localized date string: yyy-MM-dd
 * @param date Date and time to convert
 */
export function getLocalISODate(date: Date) {
    if (isNaN(date.getTime())) {
        return "";
    };
    return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + date.getDate().toString()).slice(-2))
}

/**
 * Takes a given date string and returns the UTC ISO string for the local day start or day end.
 * @param date The date string to convert
 * @param endOfDay If true then function will return end of the day otherwise the beginning. Defaults to beginning of the day.
 */
export function dateToUTCISOString(dateString: string, endOfDay = false) {
    const date = new Date(dateString);
    if (endOfDay) {
        date.setHours(23, 59, 59, 999);
    } else {
        date.setHours(0, 0, 0, 0);
    }
    return date.toISOString();
}

export function isValidDate(date: any) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

export function getFriendlyTimestamp(timestamp: number | null) {
    if (!timestamp) {
        return;
    }
    return <Moment fromNow={true}>{timestamp}</Moment>;
}

export function getFriendlyDate(date: string | null | Date) {
    if (!date) {
        return;
    }
    date = (isValidDate(date) ? (date as Date).toISOString() : date) as string;

    return getFriendlyTimestamp(Date.parse(date));
}

export function getAdminDate(date: Date | string | null, time = true, format: string = "DD/MM/YYYY HH:mm:ss z") {
    if (!date) {
        return;
    }
    date = (isValidDate(date) ? (date as Date).toISOString() : date) as string;
    return time ? <Moment tz={moment.tz.guess()} format={format} date={Date.parse(date)} />
                : <Moment format='YYYY/MM/DD' date={Date.parse(date)} />;
}


/**
 * Will return a localized date string yyy-MM-dd for the given UTC datetime and offset.
 * @param date The date to use for calculating the actual localized date string.
 * @param offset Offset used to calculate actual date in that timezone.
 */
export function getLocalizedDate(date: Date, offset: string) {
    const matches = offset.match(/^([+-])([01]\d):([0-5][05])$/);
    if (!matches || matches.length != 4) {
        throw { valid: false, error: `Invalid offset: ${offset}. Expected format: [+-]hh:mm` };
    }

    // Need to determine correct date for now given the offset provided.
    // Example: offset of -07:00 will have a different UTC date when between the hours of 12am and 6:59am UTC.
    const delta = (matches[1] == "-" ? -1 : 1) * (Number(matches[2]) * 60 + Number(matches[3]));
    const _date = new Date(date);
    _date.setUTCMinutes(_date.getUTCMinutes() + delta);
    return _date.toISOString().substr(0, 10);
}


/**
 * Parse the incoming timezone to produce a hour/minute offset to help date localization
 * @param timezone Timezone as either "Z" or [+-]hh:mm
 */
export function getOffset(timezone: string) {
    let offset = timezone || "+00:00";
    if (offset == "Z") offset = "+00:00";
    if (!RegExp(/^([+-])([01]\d):([0-5][05])$/).test(offset)) {
        const minutes = Number(offset);
        if (isNaN(minutes) || Math.abs(minutes) > 840 /* 14 hour difference if the largest offset */) {
            throw {
                valid: false,
                error: `Invalid offset: ${timezone}. Expected format of UTC: [+-]hh:mm OR Javascript: [-]mmm`
            };
        }
        const sign = minutes <= 0 ? "+" : "-";
        const hours = `0${Math.floor(Math.abs(minutes) / 60)}`.slice(-2);
        const min = `0${Math.abs(minutes) % 60}`.slice(-2);
        offset = `${sign}${hours}:${min}`;
    }
    return offset;
}

/**
 * Parse the incomming date and offset strings to produce a UTC date and corresponding timezone.
 * @param dateString Date string in the format yyyy-MM-dd
 * @param timeString Time string in the format hh:mm:ss.SSS
 * @param timezone Timezone as either "Z" or [+-]hh:mm
 */
export function parseDate(dateString: string, timeString: "00:00:00.000" | "23:59:59.999", timezone: string) {
    const offset = getOffset(timezone);
    if (!dateString) {
        dateString = getLocalizedDate(new Date(), offset);
    }

    const date = new Date(`${dateString}T${timeString}${offset}`);
    if (isNaN(date.getTime())) {
        throw { valid: false, error: `Invalid date: ${dateString}.  Expected format: yyyy-MM-dd` };
    }
    return { date, dateString, offset };
}


export function getBooleanIcon(bool: boolean, activeIcon = "fa-check", inactiveIcon = "fa-times") {
    return (
        <i
            style={{
                color: `${bool ? "green" : "red"}`
            }}
            className={`fa ${bool ? activeIcon : inactiveIcon}`}
            aria-label={bool ? "Active" : "Inactive"}
        />
    );
}

export function getArrayFromObject(obj: dynamic) {
    return Object.keys(obj).map(key => {
        return obj[key];
    });
}

function _apiRequest<T = any>(config) {
    // let's make it easier to send get requests with parameters.
    // Include the data property (as you would with a post, and
    // it will turn that into the query string for you
    if (config.method && config.method.toLowerCase() == "get") {
        if (config.data && Object.keys(config.data).length && config.url) {
            config.url = `${config.url}${config.url.indexOf("?") == -1 ? "?" : "&"}${querystring.stringify(
                config.data
            )}`;
            config.data = undefined;
        }
    }

    return Axios(config)
        .then(async response => {
            if (response.data) {
                if (typeof response.data == "object" && "valid" in response.data && !response.data.valid) {
                    if ("sessionExpired" in response.data && response.data.sessionExpired) {
                        await doLogout(response.data.error || "Your session has expired. Please log in again.");
                        return null;
                    }
                    return response.data as { valid: false; error: string };
                }
                return response.data as T;
            }
            return null;
        })
        .catch(async error => {
            const err = ((error || {}).response || {}).data || {};
            const status = ((error || {}).response || {}).status;

            // Handle 403 Forbidden (IP restriction) - logout the user
            if (status === 403) {
                await doLogout(err.error || "Access denied. Please log in again.");
                return null;
            }

            throw err.error || "An unexpected error occured while communicating with the server.";
        });
}

export function apiRequest<T = any>(url: string, method = "GET", data: dynamic | null = null) {
    return _apiRequest<T>({
        method,
        url,
        data,
        headers: {
            Accept: "application/json"
        }
    });
}

export async function apiRequestWithErrorAlert<T = any>(
    url: string,
    method = "GET",
    data: dynamic | null = null,
    errorMessage: string | null = null,
    rethrowError = false
) {
    try {
        const result = await _apiRequest<T>({
            method,
            url,
            data,
            headers: {
                Accept: "application/json"
            }
        });
        const errObj = result as { valid?: false; error?: string } | null;
        if (errObj && "valid" in errObj && !errObj.valid) {
            const error = errObj.error || "System Error";
            throw error;
        }
        return result as T | null;
    } catch (error) {
        if (errorMessage && error == "System Error") {
            createAlert(errorMessage, "error");
        } else {
            // @ts-expect-error
            createAlert(error, "error");
        }
        if (rethrowError) throw error;
    }
    return null;
}

/**
 * Polls a report job until it is complete or errors.
 *
 * @param jobStatusUrl  Full URL to GET the job status, e.g.
 *                      `${appConfig.API_URL}/reports/job/<jobId>`
 * @param onComplete    Called with the raw `data` payload when the job succeeds.
 * @param onError       Called with the error string when the job fails.
 * @param interval      Milliseconds between polls (default 5000).
 */
export function pollReportJob(
    jobStatusUrl: string,
    onComplete: (data: any, format: string) => void,
    onError: (error: string) => void,
    interval = 5000
): void {
    const poll = () => {
        apiRequest(jobStatusUrl, "GET")
            .then(result => {
                if (result === null) {
                    // apiRequest returns null after logging the user out on 401/403 — stop polling.
                    onError("Your session has expired. Please log in again.");
                } else if (result.status === "pending") {
                    setTimeout(poll, interval);
                } else if (result.status === "error") {
                    onError(result.error || "Report generation failed.");
                } else {
                    onComplete(result.data, result.format);
                }
            })
            .catch(err => {
                onError(err || "Failed to retrieve report status.");
            });
    };
    setTimeout(poll, interval);
}

export function apiFormDataPost<T = any>(url: string, formData: FormData) {
    return _apiRequest({
        method: "post",
        url,
        data: formData,
        headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data"
        }
    });
}

export function detectBody() {
    if (($(document).width() || 0) < 769) {
        $("body").addClass("body-small");
    } else {
        $("body").removeClass("body-small");
    }
}

export function smoothlyMenu() {
    if (!$("body").hasClass("mini-navbar") || $("body").hasClass("body-small")) {
        // Hide menu in order to smoothly turn on when maximize menu
        $("#side-menu").hide();
        // For smoothly turn on menu
        setTimeout(() => {
            $("#side-menu").fadeIn(400);
        }, 200);
    } else if ($("body").hasClass("fixed-sidebar")) {
        $("#side-menu").hide();
        setTimeout(() => {
            $("#side-menu").fadeIn(400);
        }, 100);
    } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $("#side-menu").removeAttr("style");
    }
}

export function getLanguages(excludeLangCode = "") {
    let languages = [
        {
          "code": "en",
          "name": "English",
          "locations": [{"code": "AU","name": "Australia"},{"code": "AT","name": "Austria"},{"code": "CA","name": "Canada"},{"code": "CN","name": "China"},{"code": "CZ","name": "Czech Republic"},{"code": "DK","name": "Denmark"},{"code": "FR","name": "France"},{"code": "DE","name": "Germany"},{"code": "HK","name": "Hong Kong"},{"code": "IN","name": "India"},{"code": "IT","name": "Italy"},{"code": "JP","name": "Japan"},{"code": "SG","name": "Singapore"},{"code": "ZA","name": "South Africa"},{"code": "KR","name": "South Korea"},{"code": "ES","name": "Spain"},{"code": "TW","name": "Taiwan"},{"code": "UK","name": "United Kingdom"},{"code": "US","name": "United States"}]
        },
          {"code": "fr","name": "French","locations": [{"code": "CA","name": "Canada"},{"code": "FR","name": "France"},{"code": "CH","name": "Switzerland"}]},
          {"code": "de","name": "German","locations": [{"code": "AT","name": "Austria"},{"code": "DE","name": "Germany"}]},
          {"code": "it","name": "Italian","locations": [{"code": "it","name": "Italy"}]},
          {"code": "pt","name": "Portuguese","locations": [{"code": "br","name": "Brazil"}]},
          {"code": "es","name": "Spanish","locations": [{"code": "AR","name": "Argentina"},{"code": "CL","name": "Chile"},{"code": "CO","name": "Colombia"},{"code": "EC","name": "Ecuador"},{"code": "MX","name": "Mexico"},{"code": "PE","name": "Peru"},{"code": "ES","name": "Spain"}]},
          {"code": "al","name": "Additional Languages", "locations": []}
    ];

    if(excludeLangCode) {
        languages = languages.filter((lang) => lang.code !== excludeLangCode);
        return JSON.parse(JSON.stringify(languages)) as Array<{ code: string; name: string; locations: Array<{ code: string; name: string }> }>;
    };

    return JSON.parse(JSON.stringify(languages)) as Array<{ code: string; name: string; locations: Array<{ code: string; name: string }> }>;
}

export function getAllLocations() {
    const locations: { [key: string]: { code: string; name: string } } = {};
    for (const loc of getLanguages()) {
        for (const l of loc.locations) {
            locations[l.code.toUpperCase()] = { code: l.code.toUpperCase(), name: l.name };
        }
    }
    return Object.values(locations);
}

export function translateLanguage(lang: string) {
    switch (lang) {
        case "fr":
            return "French";
        case "es":
            return "Spanish";
        case "de":
            return "German";
        case "pt":
            return "Portuguese";
        case "it":
            return "Italian";
        default:
        case "en":
            return "English";
    }
}

export function translateSearchType(type: string) {
    switch (type) {
        case "PERS":
            return "Personal";
        case "CORP":
            return "Corporate";
        case "PROF":
        default:
            return "Professional";
    }
}

export function getIndustries() {
    return JSON.parse(`
        [{"value":"accounting","name":"Accounting","subIndustries":["Financial accounting","Management accounting","Auditing","Accounting information systems","Tax accounting","Forensic accounting"]},{"value":"airlines/aviation","name":"Airlines/Aviation","subIndustries":["International","National","Regional","Cargo"]},{"value":"alternative dispute resolution","name":"Alternative Dispute Resolution"},{"value":"alternative medicine","name":"Alternative Medicine"},{"value":"animation","name":"Animation"},{"value":"apparel & fashion","name":"Apparel & Fashion"},{"value":"architecture & planning","name":"Architecture & Planning"},{"value":"arts and crafts","name":"Arts and Crafts"},{"value":"automotive","name":"Automotive"},{"value":"aviation & aerospace","name":"Aviation & Aerospace"},{"value":"banking","name":"Banking"},{"value":"biotechnology","name":"Biotechnology"},{"value":"broadcast media","name":"Broadcast Media"},{"value":"building materials","name":"Building Materials"},{"value":"business supplies and equipment","name":"Business Supplies and Equipment"},{"value":"capital markets","name":"Capital Markets"},{"value":"chemicals","name":"Chemicals"},{"value":"civic & social organization","name":"Civic & Social Organization"},{"value":"civil engineering","name":"Civil Engineering"},{"value":"commercial real estate","name":"Commercial Real Estate"},{"value":"computer & network security","name":"Computer & Network Security"},{"value":"computer games","name":"Computer Games"},{"value":"computer hardware","name":"Computer Hardware"},{"value":"computer networking","name":"Computer Networking"},{"value":"computer software","name":"Computer Software"},{"value":"construction","name":"Construction"},{"value":"consumer electronics","name":"Consumer Electronics"},{"value":"consumer goods","name":"Consumer Goods"},{"value":"consumer services","name":"Consumer Services"},{"value":"cosmetics","name":"Cosmetics"},{"value":"dairy","name":"Dairy"},{"value":"defense & space","name":"Defense & Space"},{"value":"design","name":"Design"},{"value":"education management","name":"Education Management"},{"value":"elearning","name":"E-Learning"},{"value":"electrical/electronic manufacturing","name":"Electrical/Electronic Manufacturing"},{"value":"entertainment","name":"Entertainment"},{"value":"environmental services","name":"Environmental Services"},{"value":"events services","name":"Events Services"},{"value":"executive office","name":"Executive Office"},{"value":"facilities services","name":"Facilities Services"},{"value":"farming","name":"Farming"},{"value":"financial services","name":"Financial Services","subIndustries":["Commercial banking services","Investment banking services","Foreign exchange services","Investment services","Insurance","Venture capital","Private equity","Financial exports"]},{"value":"fine art","name":"Fine Art"},{"value":"fishery","name":"Fishery"},{"value":"food & beverages","name":"Food & Beverages"},{"value":"food production","name":"Food Production"},{"value":"fundraising","name":"Fund-Raising"},{"value":"furniture","name":"Furniture"},{"value":"gambling & casinos","name":"Gambling & Casinos","subIndustries":["sports","casino","horse racing","games of skill","poker","fantasy","esports"]},{"value":"glass ceramics & concrete","name":"Glass,Ceramics & Concrete"},{"value":"government administration","name":"Government Administration"},{"value":"government relations","name":"Government Relations"},{"value":"graphic design","name":"Graphic Design"},{"value":"health wellness and fitness","name":"Health,Wellness and Fitness"},{"value":"higher education","name":"Higher Education"},{"value":"hospital & health care","name":"Hospital & Health Care"},{"value":"hospitality","name":"Hospitality"},{"value":"human resources","name":"Human Resources"},{"value":"import and export","name":"Import and Export"},{"value":"individual & family services","name":"Individual & Family Services"},{"value":"industrial automation","name":"Industrial Automation"},{"value":"information services","name":"Information Services"},{"value":"information technology and services","name":"Information Technology and Services"},{"value":"insurance","name":"Insurance"},{"value":"international affairs","name":"International Affairs"},{"value":"international trade and development","name":"International Trade and Development"},{"value":"internet","name":"Internet"},{"value":"investment banking","name":"Investment Banking"},{"value":"investment management","name":"Investment Management"},{"value":"judiciary","name":"Judiciary"},{"value":"law enforcement","name":"Law Enforcement"},{"value":"law practice","name":"Law Practice"},{"value":"legal services","name":"Legal Services"},{"value":"legislative office","name":"Legislative Office"},{"value":"leisure travel & tourism","name":"Leisure,Travel & Tourism"},{"value":"libraries","name":"Libraries"},{"value":"logistics and supply chain","name":"Logistics and Supply Chain"},{"value":"luxury goods & jewelry","name":"Luxury Goods & Jewelry"},{"value":"machinery","name":"Machinery"},{"value":"management consulting","name":"Management Consulting"},{"value":"maritime","name":"Maritime"},{"value":"market research","name":"Market Research"},{"value":"marketing and advertising","name":"Marketing and Advertising"},{"value":"mechanical or industrial engineering","name":"Mechanical or Industrial Engineering"},{"value":"media production","name":"Media Production"},{"value":"medical devices","name":"Medical Devices"},{"value":"medical practice","name":"Medical Practice"},{"value":"mental health care","name":"Mental Health Care"},{"value":"military","name":"Military"},{"value":"mining & metals","name":"Mining & Metals"},{"value":"motion pictures and film","name":"Motion Pictures and Film"},{"value":"museums and institutions","name":"Museums and Institutions"},{"value":"music","name":"Music"},{"value":"nanotechnology","name":"Nanotechnology"},{"value":"newspapers","name":"Newspapers"},{"value":"nonprofit organization management","name":"Non-Profit Organization Management"},{"value":"oil & energy","name":"Oil & Energy"},{"value":"online media","name":"Online Media"},{"value":"outsourcing/offshoring","name":"Outsourcing/Offshoring"},{"value":"package/freight delivery","name":"Package/Freight Delivery"},{"value":"packaging and containers","name":"Packaging and Containers"},{"value":"paper & forest products","name":"Paper & Forest Products"},{"value":"performing arts","name":"Performing Arts"},{"value":"pharmaceuticals","name":"Pharmaceuticals"},{"value":"philanthropy","name":"Philanthropy"},{"value":"photography","name":"Photography"},{"value":"plastics","name":"Plastics"},{"value":"political organization","name":"Political Organization"},{"value":"primary/secondary education","name":"Primary/Secondary Education"},{"value":"printing","name":"Printing"},{"value":"professional training & coaching","name":"Professional Training & Coaching"},{"value":"program development","name":"Program Development"},{"value":"public policy","name":"Public Policy"},{"value":"public relations and communications","name":"Public Relations and Communications"},{"value":"public safety","name":"Public Safety"},{"value":"publishing","name":"Publishing"},{"value":"railroad manufacture","name":"Railroad Manufacture"},{"value":"ranching","name":"Ranching"},{"value":"real estate","name":"Real Estate"},{"value":"recreational facilities and services","name":"Recreational Facilities and Services"},{"value":"religious institutions","name":"Religious Institutions"},{"value":"renewables & environment","name":"Renewables & Environment"},{"value":"research","name":"Research"},{"value":"restaurants","name":"Restaurants"},{"value":"retail","name":"Retail"},{"value":"security and investigations","name":"Security and Investigations"},{"value":"semiconductors","name":"Semiconductors"},{"value":"shipbuilding","name":"Shipbuilding"},{"value":"sporting goods","name":"Sporting Goods"},{"value":"sports","name":"Sports"},{"value":"staffing and recruiting","name":"Staffing and Recruiting"},{"value":"supermarkets","name":"Supermarkets"},{"value":"telecommunications","name":"Telecommunications"},{"value":"textiles","name":"Textiles"},{"value":"think tanks","name":"Think Tanks"},{"value":"tobacco","name":"Tobacco"},{"value":"translation and localization","name":"Translation and Localization"},{"value":"transportation/trucking/railroad","name":"Transportation/Trucking/Railroad"},{"value":"utilities","name":"Utilities"},{"value":"venture capital & private equity","name":"Venture Capital & Private Equity"},{"value":"veterinary","name":"Veterinary"},{"value":"warehousing","name":"Warehousing"},{"value":"wholesale","name":"Wholesale"},{"value":"wine and spirits","name":"Wine and Spirits"},{"value":"wireless","name":"Wireless"},{"value":"writing and editing","name":"Writing and Editing"}]
    `) as Array<{ value: string, name: string, subIndustries: string[]}>;
}

export function getHostName(url: string) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === "string" && match[2].length > 0) {
        return match[2];
    } else {
        return null;
    }
}

export function getDomain(url: string) {
    const hostName = getHostName(url);
    let domain = hostName;

    if (hostName != null) {
        const parts = hostName.split(".").reverse();

        if (parts != null && parts.length > 1) {
            domain = parts[1] + "." + parts[0];

            if (hostName.toLowerCase().indexOf(".co.uk") != -1 && parts.length > 2) {
                domain = parts[2] + "." + domain;
            }
        }
    }

    return domain;
}

export function getStreamsByLanguage(streams: Mongo.IStream[]) {
    const tempStreams: {
        [lang: string]: {
            [code: string]: Mongo.IStream;
        };
    } = {};
    getDefaultStreams(false).forEach(stream => {
        if (!tempStreams[stream.lang]) {
            tempStreams[stream.lang] = {};
        }
        tempStreams[stream.lang][stream.code] = stream;
    });

    if (streams && Object.keys(streams).length > 0) {
        Object.keys(streams).map(streamKey => {
            const stream = streams[streamKey];
            if (stream) {
                if (!tempStreams[stream.lang]) {
                    tempStreams[stream.lang] = {};
                }
                tempStreams[stream.lang][stream.sid] = stream;
            }
        });
    }

    const retStreams: Mongo.IStream[] = [];
    Object.keys(tempStreams).map((stream, i) => {
        getArrayFromObject(tempStreams[stream]).forEach(s => {
            retStreams.push(s);
        });
    });

    retStreams.sort((a, b) => {
        return a.streamOrder - b.streamOrder;
    });
    return retStreams;
}

export function mergeStreamsByLanguage(streams: Mongo.IStream[]) {
    const retStreams: { [sid: string]: Mongo.IStream } = {};
    getDefaultStreams(false).forEach(stream => {
        retStreams[stream.lang + "--" + stream.code] = stream;
    });

    Object.keys(streams).map((stream, i) => {
        retStreams[streams[stream].lang + "--" + streams[stream].code] = streams[stream];
    });
    return getArrayFromObject(retStreams);
}
export function uuid() {
    // http://www.ietf.org/rfc/rfc4122.txt
    const s: string[] = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((Number(s[19]) & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    const uuid = s.join("");
    return uuid;
}
export function getDefaultStreams(defaultActive: boolean) {
    return JSON.parse(`
      [{"sid":"","isDefaultStream":true,"active":${defaultActive},"searchType":"PROF","code":"PROF","title":"Professional","isApprovalRequired":false,"lastUpdatedOn":"","lang":"en","since":0,"isCustom":true,"count":3,"streamOrder":0,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false }, {"sid":"","isDefaultStream":true,"active":${defaultActive},"searchType":"PERS","code":"PERS","title":"Personal","isApprovalRequired":false,"lastUpdatedOn":"","lang":"en","since":0,"isCustom":true,"count":1,"streamOrder":1,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"CORP","code":"CORP","title":"Corporate","isApprovalRequired":false,"lastUpdatedOn":"","lang":"en","since":0,"isCustom":true,"count":1,"streamOrder":3,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"APPR","code":"APPR","title":"Approved","isApprovalRequired":true,"lastUpdatedOn":"","lang":"en","since":0,"isCustom":true,"count":1,"streamOrder":4,"isEditable":false,"isCompliant":false,"skipCompliance":false,"approved":true,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PROF","code":"PROF","title":"Professionnel","isApprovalRequired":false,"lastUpdatedOn":"","lang":"fr","since":0,"isCustom":true,"count":3,"streamOrder":0,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PERS","code":"PERS","title":"Personnel","isApprovalRequired":false,"lastUpdatedOn":"","lang":"fr","since":0,"isCustom":true,"count":1,"streamOrder":1,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"CORP","code":"CORP","title":"D'entreprise","isApprovalRequired":false,"lastUpdatedOn":"","lang":"fr","since":0,"isCustom":true,"count":5,"streamOrder":3,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"APPR","code":"APPR","title":"Approuvé","isApprovalRequired":true,"lastUpdatedOn":"","lang":"fr","since":0,"isCustom":true,"count":1,"streamOrder":4,"isEditable":false,"isCompliant":false,"skipCompliance":false,"approved":true,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PROF","code":"PROF","title":"Professionell","isApprovalRequired":false,"lastUpdatedOn":"","lang":"de","since":0,"isCustom":true,"count":3,"streamOrder":0,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PERS","code":"PERS","title":"Persönlich","isApprovalRequired":false,"lastUpdatedOn":"","lang":"de","since":0,"isCustom":true,"count":1,"streamOrder":1,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"CORP","code":"CORP","title":"Korporativ","isApprovalRequired":false,"lastUpdatedOn":"","lang":"de","since":0,"isCustom":true,"count":1,"streamOrder":3,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"APPR","code":"APPR","title":"Genehmigt","isApprovalRequired":true,"lastUpdatedOn":"","lang":"de","since":0,"isCustom":true,"count":1,"streamOrder":4,"isEditable":false,"isCompliant":false,"skipCompliance":false,"approved":true,"terms":[],"contentSearch":false  },  {"sid":"","isDefaultStream":true,"active":false,"searchType":"PROF","code":"PROF","title":"Professionista","isApprovalRequired":false,"lastUpdatedOn":"","lang":"it","since":0,"isCustom":true,"count":3,"streamOrder":0,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PERS","code":"PERS","title":"Personali","isApprovalRequired":false,"lastUpdatedOn":"","lang":"it","since":0,"isCustom":true,"count":1,"streamOrder":1,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"CORP","code":"CORP","title":"Corporativo","isApprovalRequired":false,"lastUpdatedOn":"","lang":"it","since":0,"isCustom":true,"count":1,"streamOrder":3,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"APPR","code":"APPR","title":"Approvato","isApprovalRequired":true,"lastUpdatedOn":"","lang":"it","since":0,"isCustom":true,"count":1,"streamOrder":4,"isEditable":false,"isCompliant":false,"skipCompliance":false,"approved":true,"terms":[],"contentSearch":false  },  {"sid":"","isDefaultStream":true,"active":false,"searchType":"PROF","code":"PROF","title":"Profissional","isApprovalRequired":false,"lastUpdatedOn":"","lang":"pt","since":0,"isCustom":true,"count":3,"streamOrder":0,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PERS","code":"PERS","title":"Pessoal","isApprovalRequired":false,"lastUpdatedOn":"","lang":"pt","since":0,"isCustom":true,"count":1,"streamOrder":1,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"CORP","code":"CORP","title":"Corporativo","isApprovalRequired":false,"lastUpdatedOn":"","lang":"pt","since":0,"isCustom":true,"count":1,"streamOrder":3,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"APPR","code":"APPR","title":"Aprovado","isApprovalRequired":true,"lastUpdatedOn":"","lang":"pt","since":0,"isCustom":true,"count":1,"streamOrder":4,"isEditable":false,"isCompliant":false,"skipCompliance":false,"approved":true,"terms":[],"contentSearch":false  },  {"sid":"","isDefaultStream":true,"active":false,"searchType":"PROF","code":"PROF","title":"Profesional","isApprovalRequired":false,"lastUpdatedOn":"","lang":"es","since":0,"isCustom":true,"count":3,"streamOrder":0,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"PERS","code":"PERS","title":"Personal","isApprovalRequired":false,"lastUpdatedOn":"","lang":"es","since":0,"isCustom":true,"count":1,"streamOrder":1,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"CORP","code":"CORP","title":"Corporativo","isApprovalRequired":false,"lastUpdatedOn":"","lang":"es","since":0,"isCustom":true,"count":1,"streamOrder":3,"isEditable":true,"isCompliant":false,"skipCompliance":false,"approved":false,"terms":[],"contentSearch":false  }, {"sid":"","isDefaultStream":true,"active":false,"searchType":"APPR","code":"APPR","title":"Aprobado","isApprovalRequired":true,"lastUpdatedOn":"","lang":"es","since":0,"isCustom":true,"count":1,"streamOrder":4,"isEditable":false,"isCompliant":false,"skipCompliance":false,"approved":true,"terms":[],"contentSearch":false  }]
      `);
}

function translateColour(colour: string, valueOnly: boolean, fullBackground: boolean, opacity: number) {
    if (colour.indexOf("rgb(") < 0) {
        if (valueOnly) {
            return colour;
        }
        return {
            strokeColor: colour,
            fillColor: colour,
            pointColor: colour,
            pointStrokeColor: "#fff",
            pointHighlightFill: "#fff",
            pointHighlightStroke: colour,
            backgroundColor: colour,
            borderColor: colour,
            borderWidth: 1,
            pointBackgroundColor: colour
        };
    }
    const rgba = colour.replace("rgb", "rgba");
    if (valueOnly) {
        return rgba.replace(")", ",1)");
    }
    return {
        strokeColor: rgba.replace(")", ",1)"),
        fillColor: rgba.replace(")", `,${opacity})`),

        pointColor: rgba.replace(")", ",1)"),
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: rgba.replace(")", `,1)`),
        pointBackgroundColor: rgba.replace(")", ",1)"),

        backgroundColor: rgba.replace(")", `,${fullBackground ? "1" : opacity})`),

        borderWidth: 1,
        borderColor: rgba.replace(")", `,1)`)
    };
}

const chartColoursHex = [
    "F1592A",
    "178AF7",
    "37A459",
    "FFB83D",
    "CD2F2F",
    "787982",
    "B8D9E5",
    "FABE8A",
    "FFD753",
    "868686",
    "62BADB",
    "9BE06B",
    "E35183",
    "5F5FC4"
];
export function getChartColours(valueOnly = false, fullBackground = false, byObject = false, opacity = 0.5) {
    const returnObj = chartColoursHex.map(colour =>
        translateColour(
            `rgb(${Number("0x" + colour.substring(0, 2))},${Number("0x" + colour.substring(2, 4))},${Number(
                "0x" + colour.substring(4)
            )})`,
            valueOnly,
            fullBackground,
            opacity
        )
    );
    if (byObject && !valueOnly) {
        const obj = {};
        returnObj.forEach(colourOptions => {
            Object.keys(colourOptions).forEach(k => {
                if (!(k in obj)) {
                    obj[k] = [];
                }
                obj[k].push(colourOptions[k]);
            });
        });
        return obj;
    } else {
        return returnObj;
    }
}

export function getPercent(total: number, divider: number, decimalPlaces: number) {
    if (total <= 0 || divider <= 0) {
        return 0;
    }
    if (decimalPlaces == 2) {
        return Number((total / divider).toFixed(decimalPlaces));
    } else {
        return Number(Math.round((divider / total) * 100).toFixed(decimalPlaces));
    }
}

export function stripGV6Query(Link: string) {
    // strip out query string off before we send it
    if (Link.indexOf("?") !== -1) {
        const base = Link.split("?")[0];
        const anchor = Link.split("#")[1];
        const query = querystring.parse(Link.split("?")[1]);
        if (Object.keys(query).indexOf("gv6") !== -1) {
            delete query.gv6;
            return `${base}${Object.keys(query).length ? "?" : ""}${querystring.stringify(query)}${anchor ? `#${anchor}` : ""}`;
        }
    }
    return Link;
}

export function getMultiSelectValues(select: HTMLSelectElement) {
    if (!select || !select.options || !select.options.length) {
        return [];
    }

    return getRange(0, select.options.length)
        .filter(index => {
            const opt = select.options.item(index);
            if (opt && opt.selected) {
                return true;
            }
            return false;
        })
        .map(index => (select.options.item(index) as HTMLOptionElement).value);
}

export interface IReducerAction {
    type: string;
}
export function reduce<T>(
    handlers: { [type: number]: (_: T, action: IReducerAction & T) => any },
    state: T,
    action: IReducerAction & T
) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return {
        ...(state ? state : {}),
        ...handler(state, action)
    };
}

export function shadeColor(color: string, percent: number) {
    if (color.length > 7) return shadeRGBColor(color, percent);
    else return shadeHEXColor(color, percent);
}

function shadeHEXColor(color: string, percent: number) {
    const f = Number(`0x${color.slice(1)}`);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
        "#" +
        (
            0x1000000 +
            (Math.round((t - R) * p) + R) * 0x10000 +
            (Math.round((t - G) * p) + G) * 0x100 +
            (Math.round((t - B) * p) + B)
        )
            .toString(16)
            .slice(1)
    );
}
function shadeRGBColor(color: string, percent: number) {
    const f = color.split(",");
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = Number(f[0].slice(4));
    const G = Number(f[1]);
    const B = Number(f[2]);
    return (
        "rgb(" +
        (Math.round((t - R) * p) + R) +
        "," +
        (Math.round((t - G) * p) + G) +
        "," +
        (Math.round((t - B) * p) + B) +
        ")"
    );
}

function generateBrandCSSSection(color: string, cls: string, mod = "", colorMod = "") {
    return `${cls}--color${mod} {
        color: ${color} ${colorMod};
    }

    ${cls}--bg${mod} {
        background-color: ${color} ${colorMod};
    }

    ${cls}--border${mod} {
        border-color: ${color} ${colorMod};
    }`;
}

export function generateBrandCSS(primaryColor: string) {
    const darkPrimary = shadeColor(primaryColor, -0.1);
    const lightPrimary = shadeColor(primaryColor, 0.45);
    return `
    .brandPrimary a {
        color: ${primaryColor};
    }
    .brandPrimary a:hover {
        color: ${darkPrimary};
    }

    a.brandPrimary--bg {
        background-color: ${primaryColor} !important;
    }

    a.brandPrimary--bg:hover {
        background-color: ${darkPrimary} !important;
    }

    ${generateBrandCSSSection(primaryColor, ".brandPrimary")}
    ${generateBrandCSSSection(darkPrimary, ".brandPrimary", ".active")}
    ${generateBrandCSSSection(darkPrimary, "button.brandPrimary", ":hover")}
    ${generateBrandCSSSection(darkPrimary, "a.brandPrimary", ":hover")}
    ${generateBrandCSSSection(darkPrimary, ".brandPrimary__dark")}
    ${generateBrandCSSSection(lightPrimary, ".brandPrimary__light")}
    ${generateBrandCSSSection(lightPrimary, ".brandPrimary__light__important", "", "!important")}
    `;
}
export function expand(key: string, value: any) {
    const items = key.split(".");
    const output = {};
    let ref = output;
    for (const [i, item] of items.entries()) {
        ref[item] = i + 1 === items.length ? value : {};
        ref = ref[item];
    }

    return output;
}
export function unflatten(data: dynamic) {
    if (Object(data) !== data || Array.isArray(data)) {
        return data;
    }
    const regex = /\.?([^.\[\]]+)|\[(\d+)\]/g;
    const resultholder = {};
    for (const p in data) {
        let cur = resultholder;
        let prop = "";
        let m: string[] | null;
        while (m = regex.exec(p)) {
            cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
            prop = m[2] || m[1];
        }
        cur[prop] = data[p];
    }
    return resultholder[""];
}

export function flatten(object: dynamic) {
    const returnObject = {};

    for (const key in object) {
        if (!(key in object)) continue;

        if (typeof object[key] == "object") {
            const flatObject = flatten(object[key]);
            for (const k in flatObject) {
                if (!(k in flatObject)) continue;

                returnObject[key + "." + k] = flatObject[k];
            }
        } else {
            returnObject[key] = object[key];
        }
    }
    return returnObject;
}

export function isIE11() {
    if (!!window["MSInputMethodContext"] && !!document["documentMode"]) {
        return true;
    }
    return false;
}

export function updateIEWidth() {
    const width = window.innerWidth;
    let newWidth = "";
    if ($("body").hasClass("mini-navbar") || width <= 768) {
        newWidth = width.toString();
        newWidth += "px";
    } else {
        newWidth = (width - 260).toString();
        newWidth += "px";
    }
    return newWidth;
}

export const deepCopy = (sourceObject, newPropertyObject) => {
    const obj = JSON.parse(JSON.stringify(sourceObject));
    for (const prop in newPropertyObject) {
        if (prop in obj) {
            if (newPropertyObject[prop] == null) {
                delete obj[prop];
            } else {
                obj[prop] =
                    isObject(newPropertyObject[prop]) && isObject(obj[prop])
                        ? deepCopy(obj[prop], newPropertyObject[prop])
                        : newPropertyObject[prop];
            }
        }
    }
    return obj;
};

export const deepEqual = (x, y) => {
    const ok = Object.keys;
    const tx = typeof x;
    const ty = typeof y;
    return x && y && tx === "object" && tx === ty
        ? ok(x).length === ok(y).length && ok(x).every(key => deepEqual(x[key], y[key]))
        : x === y && ((x != null && y != null) || x.constructor === y.constructor);
};

export const isObject = item => {
    return item && typeof item === "object" && !Array.isArray(item);
};

export const deepMerge = (target, ...sources) => {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                deepMerge(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return deepMerge(target, ...sources);
};

/**
 * @author Steven Masala [me@smasala.com]
 * Github: https://github.com/smasala/responsive-tables-js
 * @license: MIT https://tldrlegal.com/license/mit-license
 * Responsive Tables
 * @version 1.0.0
 */
export const initResponsiveTables = (selector: string, force = false) => {
    const tables = $(selector ? selector : "table.responsive");
    let table;
    let ths;
    let th;
    let trs;
    let tds;
    let text;
    let it;
    if (tables.length > 0) {
        for (let i = 0, l = tables.length; i < l; i++) {
            table = $(tables[i]);
            if (table.attr("data-type") && !force) {
                continue;
            }
            table.attr("data-type", "responsive");
            trs = table.find("> thead > tr, > tbody > tr, > tr");
            ths = trs.find("> th");
            for (let ii = 0, ll = trs.length; ii < ll; ii++) {
                tds = $(trs[ii]).find("> td");
                for (let iii = 0, lll = tds.length; iii < lll; iii++) {
                    th = ths[iii];
                    it = $(tds[iii]);
                    // Removing child nodes so that things like the Tooltip don't show up
                    text = ($(th)
                        .clone()
                        .children()
                        .remove() as dynamic).prevObject.text();
                    if (it.attr("colspan") == 42) {
                        continue;
                    }
                    if (force) {
                        it.find("span[data-type='responsive']").remove();
                    }
                    if (text) {
                        it.prepend("<span data-type='responsive'>" + text + ":</span>");
                    }
                }
            }
        }
    }
};

export const getAdmin = (admin: Mongo.clientAdmin) => {
    if (!admin) {
        return { name: "Development Admin", role: "Super Admin" };
    }
    return {
        name: admin.name || "",
        role: "",
        ...(admin.isSuper ? { role: "Super Admin" } : null),
        ...(admin.isApiAdmin ? { role: "API Admin" } : null),
        ...(admin.isSuperClientAdmin ? { role: "Super Client Admin" } : null),
        ...(admin.isClientAdmin ? { role: "Client Admin" } : null),
        ...(admin.isAdmin && admin.isCurator ? { role: "Curator Admin, User Admin" } : null),
        ...(admin.isAdmin ? { role: "User Admin" } : null),
        ...(admin.isCurator ? { role: "Curator Admin" } : null),
        ...(admin.isReports ? { role: "Reports Admin" } : null)
    };
};

export const hasEmvPermission = (admin: Mongo.clientAdmin) => {
    return admin.isSuper || admin.isApiAdmin || admin.isSuperClientAdmin || admin.isClientAdmin;
}

export function buildFormData<T>(data: T, ignoreKeys?: Array<keyof T>, files?: File[], thumbnailFile?: File) {
    const formData = new FormData();
    if (files) {
        files.forEach(file => formData.append("file", file));
        // will need Image for article image so don't remove it
        if (data["type"] && data["type"] != "Article" && data["type"] != "Media"){
            delete data["Image"];
        }
    }
    if (thumbnailFile) formData.append("file", thumbnailFile);

    Object.keys(data as dynamic).filter(key => (ignoreKeys || []).indexOf(key as unknown as keyof T) === -1).forEach(key => {
        if (data[key] === undefined) { return; }
        if (Array.isArray(data[key])) {
            if (data[key] && data[key].length) {
                for (const v of (data[key] as any[])) {
                    formData.append(`${key}[]`, v);
                }
            } else {
                formData.append(key, JSON.stringify(data[key]));
            }
        } else {
            let value = data[key];
            if (value instanceof Date && value.toString() !== "Invalid Date") {
                // auto process dates
                value = value.toISOString();
            }
            formData.append(key, typeof value === "string" ? value : JSON.stringify(value)); // will handle numbers, strings, other objects
        }
    });
    return formData;
}

export function upperCaseFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function lowerCaseFirstLetter(str: string) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}

export function checkForDuplicates(collection: Array<string>) {
    return new Set(collection).size !== collection.length
}

export function sanitizeHtml(str: string) {
    // !!! sanitize-html escapes ALL text content - this means that ampersands, greater-than, and
    // less-than signs are converted to their equivalent HTML character references !!!
    return sanitizeHtml(str).trim().replace(/&amp;/g, "&");
};

export function getNetworkLimits() {
    return {
        linkedIn: {
            commentCharacters: 3000,
            videoSeconds: 600,
            maxWidth: null,
            aspectRatioMax: 16 / 9,
            aspectRatioMin: 9 / 16
        },
        facebook: {
            commentCharacters: 3000,
            videoSeconds: 600,
            maxWidth: null,
            aspectRatioMax: 16 / 9,
            aspectRatioMin: 9 / 16
        },
        instagram: {
            commentCharacters: 2200,
            videoSeconds: 600,
            maxWidth: 1920,
            aspectRatioMax: 1.91 / 1, // Instagram Feed Posts: max 1.91:1 (landscape)
            aspectRatioMin: 4 / 5     // Instagram Feed Posts: min 4:5 (portrait)
        },
        twitter: {
            commentCharacters: 280,
            videoSeconds: 140,
            maxWidth: null,
            aspectRatioMax: 16 / 9,
            aspectRatioMin: 9 / 16
        },
        webShare: {
            commentCharacters: 100,
            videoSeconds: 600,
            maxWidth: null,
            aspectRatioMax: 16 / 9,
            aspectRatioMin: 9 / 16
        }
    }
}